import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
const loadReportWidget = () => import( /* webpackChunkName: "dashboard-widget" */'dashboard-ui-components/components/widgets/DashboardReportWidget');
export const AsyncDashboardReportWidget = Loadable({
  loader: loadReportWidget,
  LoadingComponent: () => null
});
const loadEmailWidget = () => import( /* webpackChunkName: "email-widget" */'dashboard-ui-components/components/widgets/email/EmailWidget');
export const AsyncEmailWidget = Loadable({
  loader: loadEmailWidget,
  LoadingComponent: () => /*#__PURE__*/_jsx(UILoadingSpinner, {
    grow: true
  })
});